import {
	Component,
	EventEmitter,
	Input,
	OnChanges,
	OnDestroy,
	Output,
	SimpleChanges,
	ViewChild,
} from '@angular/core';
import * as Highcharts from 'highcharts/highstock';
import { HighchartsChartComponent } from 'highcharts-angular';
import { isNotNuloOuUndefined } from '@utils';

@Component({
	selector: 'seira-high-stock',
	templateUrl: './high-stock.component.html',
	styleUrls: ['./high-stock.component.scss'],
})
export class HighStockComponent implements OnChanges, OnDestroy {
	@ViewChild('highchartsGrafico') chartRef!: HighchartsChartComponent;
	@Output() chartInstance = new EventEmitter<Highcharts.StockChart>();
	@Input() classChart = 'highcharts-light h-auto';
	@Input() options!: Highcharts.Options;
	@Input() styleChart = 'width: 100%; height: 600px; display: block';
	@Input() updateFlag = false;
	@Input() id?: string;

	protected readonly Highcharts = Highcharts;

	private static nextContainerId = 0;
	private chart: Highcharts.StockChart | undefined;
	private readonly defaultContainerId = `highchartsGrafico-${HighStockComponent.nextContainerId++}`;
	private height = 600;

	get chartContainerId(): string {
		return this.id ?? this.defaultContainerId;
	}

	chartCallback: Highcharts.ChartCallbackFunction = chart => {
		chart.update(this.options, true);
		this.chart = chart;
		this.chartInstance.emit(chart);
	};

	ngOnChanges(changes: SimpleChanges) {
		if (changes['updateFlag'] && changes['updateFlag'].currentValue === true) {
			this.updateChart();
		}
	}

	private updateChart() {
		if (this.chart) {
			this.chart.update(this.options, true, true);
		}
	}

	ngOnDestroy() {
		if (this.chart && Object.keys(this.chart).length) {
			this.chart.destroy();
		}
	}

	capturaAltura(filtro: number) {
		this.height = filtro * 200 + (180 - 20 * filtro);
	}

	reiniciarGrafico(
		options: Highcharts.Options,
		filtro?: number,
		alturaEmPx?: number
	) {
		if (this.chart) {
			this.chart = new Highcharts.StockChart(this.chartContainerId, options);
			if (isNotNuloOuUndefined(filtro)) {
				this.capturaAltura(filtro!);
			} else {
				this.height = alturaEmPx!;
			}
			this.chart!.setSize(null, this.height);
			this.chartInstance.emit(this.chart);
		}
	}
	geraURLdoGrafico() {
		const chartOptions: Highcharts.Options = {
			chart: {
				width: 1200,
			},
		};

		const svg = this.chart?.getSVG(chartOptions) || '';
		const blob = new Blob([svg], { type: 'image/svg+xml' });
		return URL.createObjectURL(blob);
	}

	update() {
		this.chart?.destroy();
		// @ts-ignore
		this.chartRef.chart = undefined;
		this.chart = undefined;
		this.updateFlag = true;
	}
}
